<template>
    <div>
        <section id="soon" class="">
            <div class="container">
                <div class="c">
                    <div class="logo">
                        <img src="../assets/images/layout/logotop.png" alt="">

                    </div>
                    <div>
                        <h1>BREVEMENTE</h1>
                    </div>
                    <div class="image">
                        <img src="../assets/images/soon/BrevementeImagem.png" alt="">

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { removeChatMixin } from "../plugins/removeChatMixin";
export default {
  mixins: [removeChatMixin]
};
</script>
<style scoped lang="scss">
.c {
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.c h1 {
  font-size: 3rem;
  color: black;
  font-weight: 300;
}

.container {
  height: 100%;
}
#soon {
  background-color: white;
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
}
.image {
  max-width: 30rem;
}

.logo {
  max-width: 30rem;
  border-bottom: solid 1px #e90054;
}
</style>



// WEBPACK FOOTER //
// src/pages/ComingSoon.vue